<template>
    <div v-if="showTour && sizeScreen()" id="my-tour" :class="classMenu" class="my-tour">
        <v-tour name="myTour" :steps="steps" :callbacks="callbacks">
            <template slot-scope="tour">
                <transition name="fade" mode="out-in">
                    <v-step v-if="tour.currentStep === index" v-for="(step, index) of tour.steps" :key="index"
                        :step="step" :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop"
                        :isFirst="tour.isFirst" :isLast="tour.isLast" :labels="tour.labels" class="step">
                        <template>
                            <div slot="content">
                                <i @click="tour.stop" class="material-icons icon-close">close</i>
                                <div v-if="step.content" v-html="step.content" class="step-content"></div>
                            </div>
                            <div slot="actions">
                                <button @click="tour.previousStep" v-if="!tour.isFirst"
                                    class="btn grey-light waves-effect waves-light">Voltar</button>
                                <button @click="tour.nextStep" v-if="!tour.isLast" id="tour-next"
                                    class="btn btn-default waves-effect waves-light">Avançar</button>
                            </div>
                        </template>
                    </v-step>
                </transition>
            </template>
        </v-tour>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import TourStore from '@/store/tour';
    export default {
        name: 'my-tour',
        props: ['steps'],
        data() {
            return {
                showTour: true,
                classMenu: '',
                currentStep: null,
                callbacks: {
                    onPreviousStep: this.myCustomPreviousStepCallback,
                    onNextStep: this.myCustomNextStepCallback,
                    onStop: this.myCustomNextStopCallback,
                }
            }
        },
        created: function () {
            // console.log('passos', this.steps);
            $('.step-parent').removeClass('step-parent');
            $('#left-sidebar-nav').removeClass('nav-expanded').addClass('nav-collapsed');
        },
        mounted: function () {
            // if(window.innerWidth > 780){

            this.show = TourStore.show();
            // debugger;
            if (!this.show) {
                this.myCustomNextStopCallback();
                return;
            }

            this.$tours['myTour'].start();
            // A dynamically added onStop callback
            this.callbacks.onStart = () => {

                if (this.steps[0].params.hasOwnProperty('bgTransparent') && this.steps[0].params.bgTransparent) {
                    $(this.steps[0].parent).addClass('step-parent--transparent').addClass(this.steps[0].params.bgClass || '');
                }
                $('.step-target').removeClass('step-parent');
                $(this.steps[0].parent).addClass('step-parent');

                $(this.steps[0].target).addClass('step-target');

            }
            // }
        },
        methods: {
            sizeScreen() {
                return window.innerWidth > 780;
            },
            onStartTour: function () {
                // alert(0);
                // $(this.steps[0].target);
                // debugger;
            },
            nextStep() {
                this.$tours['myTour'].nextStep();
                if (this.steps[this.$tours['myTour'].currentStep].params.hasOwnProperty('bgTransparent') && this.steps[this.$tours['myTour'].currentStep].params.bgTransparent) {
                    $(this.steps[this.$tours['myTour'].currentStep].parent).addClass('step-parent--transparent').addClass(this.steps[this.$tours['myTour'].currentStep].params.bgClass || '');
                }
                $('.step-target').removeClass('step-target');
                $('.step-parent').removeClass('step-parent');
                $(this.steps[this.$tours['myTour'].currentStep].parent).addClass('step-parent');
                $(this.steps[this.$tours['myTour'].currentStep].target).addClass('step-target');
                // console.log(33333, document.querySelector('.v-step.step'));
                document.querySelector('.v-step.step').scrollIntoView({ behavior: 'smooth' })

            },
            showLastStep() {
                // alert(2);
                this.$tours['myTour'].currentStep = this.steps.length - 1
            },
            myCustomPreviousStepCallback(currentStep) {
                // console.log('myCustomPreviousStepCallback', currentStep, this.steps);
                // console.log(this.steps[currentStep].params.menu);
                // debugger;
                if (this.steps[currentStep].params.menu) {
                    $('#left-sidebar-nav').removeClass('nav-expanded').addClass('nav-collapsed');
                    this.classMenu = '';
                } else {
                    if (currentStep !== 0) {
                        this.classMenu = 'has-menu-class';
                    }
                }
                try {
                    if (this.steps[currentStep - 2].params.subMenu) {
                        $(this.steps[currentStep - 2].params.subMenuTarget).next('.collapsible-body').hide();
                        $(this.steps[currentStep - 2].params.subMenuTarget).parents('li').removeClass('active');

                        this.classMenu = 'has-menu-class';
                    } else {
                        this.classMenu = '';
                    }

                } catch (ex) {

                }
                if (this.steps[currentStep - 1].params.menu) {
                    $('#left-sidebar-nav').addClass('nav-expanded').removeClass('nav-collapsed');
                    this.classMenu = '';
                }
                $(this.steps[currentStep].parent).removeClass('step-parent').removeClass('step-parent--transparent').removeClass(this.steps[currentStep].params.bgClass || '');
                $(this.steps[currentStep].target).removeClass('step-target');

                if (this.steps[currentStep - 1].params.hasOwnProperty('bgTransparent') && this.steps[currentStep - 1].params.bgTransparent) {
                    $(this.steps[currentStep - 1].parent).addClass('step-parent--transparent').addClass(this.steps[currentStep - 1].params.bgClass || '');
                }

                $(this.steps[currentStep - 1].parent).addClass('step-parent');

                $(this.steps[currentStep - 1].target).addClass('step-target');
            },
            myCustomNextStepCallback(currentStep) {
                // console.log('myCustomNextStepCallback', currentStep, this.steps);
                // alert(1);
                // console.log(this.steps);
                // console.log('current', currentStep);
                // console.log(document.querySelector('.v-step.step'));
                // document.querySelector('.step-parent').scrollIntoView({behavior: 'smooth'})
                // console.log('current', this.$tours['myTour'], this.steps[this.$tours['myTour'].currentStep]);
                // debugger;
                if (this.steps[currentStep].params.menu && this.steps[currentStep].target !== this.steps[currentStep].parent) {
                    this.classMenu = 'has-menu-class';
                    $('#left-sidebar-nav').removeClass('nav-expanded').addClass('nav-collapsed');
                }
                else {
                    this.classMenu = '';
                }
                try {
                    if (this.steps.length > 2 && this.steps[currentStep + 2].params.subMenu) {
                        $(this.steps[currentStep + 2].params.subMenuTarget).next('.collapsible-body').show();
                        $(this.steps[currentStep + 2].params.subMenuTarget).parents('li').addClass('active');
                    } else if ((this.steps.length == 2 || this.steps.length == 3) && this.steps[currentStep + 1].params.subMenu) {
                        $(this.steps[currentStep + 1].params.subMenuTarget).next('.collapsible-body').show();
                        $(this.steps[currentStep + 1].params.subMenuTarget).parents('li').addClass('active');
                    }
                    else {
                        this.classMenu = '';
                    }

                } catch (ex) {

                }
                if (this.steps[currentStep + 1].params.menu && this.steps[currentStep + 1].target !== this.steps[currentStep + 1].parent) {

                    $('#left-sidebar-nav').find('.side-nav').addClass('remove-effect').addClass('bg-fk');
                    this.classMenu = 'has-menu-class';
                    $('#left-sidebar-nav').addClass('nav-expanded').removeClass('nav-collapsed');
                    $(this.steps[currentStep + 1].target).css('background-color', '#FFF !important');
                } else {
                    this.classMenu = '';
                }
                $(this.steps[currentStep].parent).removeClass('step-parent').removeClass('step-parent--transparent').removeClass(this.steps[currentStep].params.bgClass || '');
                $(this.steps[currentStep].target).removeClass('step-target');
                if (this.steps[currentStep + 1].params.hasOwnProperty('bgTransparent') && this.steps[currentStep + 1].params.bgTransparent) {
                    $(this.steps[currentStep + 1].parent).addClass('step-parent--transparent').addClass(this.steps[currentStep + 1].params.bgClass || '');
                }

                $('.step-target').removeClass('step-target');
                $(this.steps[currentStep + 1].parent).addClass('step-parent');
                $(this.steps[currentStep + 1].target).addClass('step-target');

                if (this.steps[currentStep].params.menu) {
                    this.$router.push(this.steps[currentStep].params.route);
                } else if (this.steps[currentStep].params.hasOwnProperty('table') && this.steps[currentStep].params.table.enable) {
                    $(this.steps[currentStep].params.table.target).first(0).click();
                }

                if (this.steps[currentStep + 1].params.hasOwnProperty('toTop') && this.steps[currentStep + 1].params.toTop) {
                    setTimeout(() => {
                        document.querySelector('#my-tour').scrollIntoView();
                    }, 300);
                }
            },

            myCustomNextStopCallback() {
                TourStore.disable();
                $('.my-tour').hide();
                $('.step-parent').removeClass('step-parent');
                $('.step-target').removeClass('step-target');
                $('.step-parent--transparent').removeClass('step-parent--transparent');

                const tour = this.$tours['myTour'];

                while (this.steps[tour.currentStep] == undefined && this.currentStep <= this.$tours['myTour'].steps.length) {
                    $(this.steps[this.$tours['myTour'].currentStep].parent).removeClass('step-parent').removeClass('step-parent--transparent').removeClass(this.steps[this.$tours['myTour'].currentStep].params.bgClass || '');
                    $(this.steps[this.$tours['myTour'].currentStep].parent).removeClass('step-target');
                }
            }
        }
    }
</script>

<style scoped>
    #my-tour .btn {
        line-height: 26px !important;
    }

    .step-content {
        padding-bottom: 20px;
        padding-top: 20px;
    }

    .has-menu-class .step {
        left: 495px !important;
    }

    .step {
        z-index: 99999999 !important;
        background-color: #fff !important;
        color: #000 !important;
        position: relative !important;
    }

    .icon-close {
        position: absolute;
        top: 3px;
        right: 3px;
        /* font-size: 1.2rem; */
        color: #cccccc;
    }

    .icon-close:hover {
        /* animation: rotation 2s ease; */
        color: #d55;
        cursor: pointer;
    }

    .v-step__arrow {
        border-color: #fff;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.25s ease-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .my-tour {

        position: absolute;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        background-color: rgba(0, 0, 0, .8);
        z-index: 99999;
        top: 0;
        left: 0;
    }

    .my-tour--transparent {
        background-color: transparent;
    }

    @-webkit-keyframes rotation {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(185deg);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/MyTour.vue